/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardCompetitionsMyRanksBody
 */
export interface LeaderboardCompetitionsMyRanksBody {
    /**
     * Leaderboard IDs or slugs to look up. Max 50.
     * @type {Array<string>}
     * @memberof LeaderboardCompetitionsMyRanksBody
     */
    idOrSlugs: Array<string>;
}

/**
 * Check if a given object implements the LeaderboardCompetitionsMyRanksBody interface.
 */
export function instanceOfLeaderboardCompetitionsMyRanksBody(value: object): value is LeaderboardCompetitionsMyRanksBody {
    if (!('idOrSlugs' in value) || value['idOrSlugs'] === undefined) return false;
    return true;
}

export function LeaderboardCompetitionsMyRanksBodyFromJSON(json: any): LeaderboardCompetitionsMyRanksBody {
    return LeaderboardCompetitionsMyRanksBodyFromJSONTyped(json, false);
}

export function LeaderboardCompetitionsMyRanksBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardCompetitionsMyRanksBody {
    if (json == null) {
        return json;
    }
    return {
        
        'idOrSlugs': json['idOrSlugs'],
    };
}

export function LeaderboardCompetitionsMyRanksBodyToJSON(json: any): LeaderboardCompetitionsMyRanksBody {
    return LeaderboardCompetitionsMyRanksBodyToJSONTyped(json, false);
}

export function LeaderboardCompetitionsMyRanksBodyToJSONTyped(value?: LeaderboardCompetitionsMyRanksBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idOrSlugs': value['idOrSlugs'],
    };
}

